import methods from "../Service";
import useHttpParamsJsonCreate from "hooks/useHttpParamsJsonCreate";
const useParamsJson = (param) => { return useHttpParamsJsonCreate(param); }
const ImpuestoRetener= {

    async Get() { return await methods.Get("ImpuestoRetener/Get") },
   // async Get() { return await methods.Get("LiquidacionCompraDetalleTemp/Get" ) },
    async Post(data) { return await methods.Post("ImpuestoRetener/Post", data) },
    async Put(qs, data) { return await methods.Put("ImpuestoRetener/Put" + useParamsJson(qs), data) },
    async Delete(qs) { return await methods.Delete("ImpuestoRetener/Delete" + useParamsJson(qs)) }
};

export default ImpuestoRetener;